import React, { useEffect, useState } from "react";
import {
  Navbar,
  Offcanvas,
  Nav,
  Container,
  OverlayTrigger,
  Tooltip,
  Modal,
  Badge,
  Form,
  InputGroup,
  Button,
  Col,
  Row,
} from "react-bootstrap";
import { FaRegUser } from "react-icons/fa6";
import { FaRegHeart, FaSearch } from "react-icons/fa";
import { FiMenu } from "react-icons/fi";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./AppNavbar.css";
import UserLoginForm from "../User/UserLogin/UserLoginForm";
import {
  handleCheckUserLogin,
  handleUserSetLocalStorage,
} from "../../MIS/Global";
import { deleteCookieFromDB } from "../../MIS/indexedDBUtils";
import { MdLogout } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  setUserLogin,
  setUserLoginModal,
  setUserWishList,
} from "../../API/Reducer/userReducer";
import { useWishlistQuery } from "../../API/Model/useWishlistModel";
import UserWishListPage from "../User/UserWishlist/UserWishListPage";
import CreativeNavMenu from "./CreativeNavMenu";
import vLogo from "../../Assets/vLogo.png";
import hLogo from "../../Assets/hLogo.png";
import UserSidebarMenu from "../NavBar/UserSidebarMenu";
import UserDropdown from "./UserDropdown";
import { encrypt } from "../../MIS/encryption";

function AppNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { userLogin, userLoginModal, userWishList } = useSelector(
    (state) => state.user
  );
  const { mpid = 0, subid = 0, searchQuery = "" } = useParams();
  const [lastScrollY, setLastScrollY] = useState(0);
  const [smShow, setSmShow] = useState(false || userLoginModal);
  const [isLogin, setIsLogin] = useState(false);
  const [show, setShow] = useState(false);
  const [menuShow, setMenuShow] = useState(false);
  const [searchString, setSearchString] = useState(searchQuery);
  const [searchBoxHide, setSearchBoxHide] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleMenuClose = () => setMenuShow(false);
  const handleMenuShow = () => setMenuShow(true);

  const filterData = {
    loginid: handleCheckUserLogin("userData", "id"),
    prod_type: 0,
  };
  const { refetch: refetchWishlistProducts } = useWishlistQuery(filterData);

  const renderTooltip = (props, title = "Simple Tooltip") => (
    <Tooltip id="button-tooltip" {...props}>
      {title}
    </Tooltip>
  );

  const handleLogOut = async () => {
    await deleteCookieFromDB("jcUserToken");
    handleUserSetLocalStorage([], "userData", true);
    dispatch(setUserLogin());
    dispatch(setUserWishList([]));
    navigate("/")
  };

  useEffect(() => {
    if (handleCheckUserLogin("userData", "id") !== 0) {
      setIsLogin(true);
    } else {
      setIsLogin(false);
    }
  }, [userLogin, location, userLoginModal]);

  useEffect(() => {
    if (userLoginModal === true) {
      setSmShow(true);
      dispatch(setUserLoginModal());
    }
  }, [userLoginModal]);

  const handleGetWishlist = async () => {
    let isLogin = handleCheckUserLogin("userData", "id");
    if (isLogin <= 0) {
      return;
    }
    try {
      const response = await refetchWishlistProducts();
      dispatch(setUserWishList(response?.data));
    } catch (error) {
    } finally {
    }
  };
  useEffect(() => {
    handleGetWishlist();
  }, [isLogin]);

  const toggleSearchBoxHide = () => {
    setSearchBoxHide((prev) => !prev);
  };

  const handleSearch = () => {
    const trimmedSearch = searchString.trim();
    if (trimmedSearch !== "") {
      window.location.href = `/tbk/${encrypt(0)}/${trimmedSearch}`;
    }
  };
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top shadow-sm">
        <Container fluid className="d-flex flex-column">
          {/* First Row - Main Navbar */}
          <Row className="align-items-center g-0 w-100">
            {/* Left Side - Logo & Menu Button */}
            <Col xs={6} md={3} className="d-flex gap-1 align-items-center">
              <Button
                type="button"
                onClick={() => {
                  handleMenuShow();
                }}
                variant="light"
                // className="d-lg-none border-0"
                className="border-0"
              >
                <FiMenu size={24} />
              </Button>
              <Navbar.Brand
                className="fw-bold pointer"
                onClick={() => {
                  navigate("/");
                  setSearchString("");
                }}
              >
                <img
                  src={hLogo}
                  alt="TeeBlanka Logo"
                  className="d-none d-md-block"
                  style={{ height: "50px", width: "auto" }}
                />

                <img
                  src={hLogo}
                  alt="TeeBlanka Logo"
                  className="d-md-none"
                  // style={{ height: "40px" }}
                  style={{ height: "40px", objectFit: "contain" }}
                />
              </Navbar.Brand>
            </Col>

            {/* Middle - Search Bar (Hidden on Small Screens) */}
            <Col
              xs={12}
              md={6}
              className="d-none d-md-flex justify-content-center"
            >
              {(searchBoxHide || searchQuery !== "") && (
                <Form className="d-flex w-100 px-2">
                  <InputGroup>
                    <Form.Control
                      type="search"
                      placeholder="Search by name,color,code..."
                      aria-label="Search"
                      value={searchString}
                      onChange={(e) => {
                        setSearchString(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && searchString.trim() !== "") {
                          e.preventDefault(); // Prevents the default form submission behavior
                          handleSearch();
                        }
                      }}
                    />
                    <Button
                      variant="outline-success"
                      disabled={searchString !== "" ? false : true}
                      type="button"
                      onClick={() => {
                        // navigate(`/tbk/0/${searchString.trim()}`,{ replace: true })
                        // window.location.href = `/tbk/0/${searchString.trim()}`;
                        handleSearch();
                      }}
                    >
                      Search
                    </Button>
                  </InputGroup>
                </Form>
              )}
            </Col>

            {/* Right Side - User & Wishlist Icons */}
            <Col
              xs={6}
              md={3}
              className="d-flex justify-content-end gap-1 align-items-center"
            >
              <OverlayTrigger
                placement="left"
                delay={{ show: 250, hide: 300 }}
                overlay={(props) => renderTooltip(props, "Search")}
              >
                <div
                  onClick={() => {
                    toggleSearchBoxHide();
                  }}
                  style={{
                    border: "none",
                    backgroundColor: "transparent",
                    cursor: "pointer",
                  }}
                >
                  <FaSearch
                    style={{ fontSize: "16px", color: "#333" }}
                    className="me-2"
                  />
                </div>
              </OverlayTrigger>
              {/* User Login/Logout */}
              {/* <OverlayTrigger
                placement="left"
                delay={{ show: 250, hide: 400 }}
                overlay={(props) =>
                  renderTooltip(props, isLogin ? "Logout" : "Login")
                }
              >
                {isLogin === false ? (
                  <div
                    onClick={() => setSmShow(true)}
                    style={{
                      border: "none",
                      backgroundColor: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    <FaRegUser style={{ fontSize: "16px" }} />
                  </div>
                ) : (
                  <div
                    onClick={() => {
                      handleLogOut();
                    }}
                    style={{
                      border: "none",
                      backgroundColor: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    <MdLogout style={{ fontSize: "16px" }} />
                  </div>
                )}
              </OverlayTrigger> */}
              <UserDropdown
                isLogin={isLogin}
                setSmShow={setSmShow}
                handleLogOut={handleLogOut}
                navigate={navigate}                
              />
              {/* Wishlist */}
              <OverlayTrigger
                placement="left"
                delay={{ show: 250, hide: 400 }}
                overlay={(props) => renderTooltip(props, "Wishlist")}
              >
                <div
                  onClick={() => {
                    handleShow();
                  }}
                  style={{
                    border: "none",
                    backgroundColor: "transparent",
                    cursor: "pointer",
                  }}
                >
                  <FaRegHeart style={{ fontSize: "16px" }} className="ms-2" />
                  <sup>
                    <Badge bg="danger" className="rounded">
                      {userWishList?.length > 99 ? "99+" : userWishList?.length}
                    </Badge>
                  </sup>
                </div>
              </OverlayTrigger>
            </Col>

            {/* Search Bar (Visible Only on Small Screens) */}
            <Col xs={12} className="d-md-none mt-2">
              {(searchBoxHide || searchQuery !== "") && (
                <Form className="d-flex">
                  <InputGroup>
                    <Form.Control
                      type="search"
                      placeholder="Search by name,color,code..."
                      aria-label="Search"
                      value={searchString}
                      onChange={(e) => {
                        setSearchString(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && searchString.trim() !== "") {
                          e.preventDefault(); // Prevents the default form submission behavior
                          handleSearch();
                        }
                      }}
                    />
                    <Button
                      disabled={searchString !== "" ? false : true}
                      type="button"
                      onClick={() => {
                        // navigate(`/tbk/0/${searchString.trim()}`,{ replace: true })
                        // window.location.href = `/tbk/0/${searchString.trim()}`;
                        handleSearch();
                      }}
                      variant="outline-success"
                    >
                      Search
                    </Button>
                  </InputGroup>
                </Form>
              )}
            </Col>
          </Row>

          {/* Second Row - Navigation Links */}
          <Row className="mt-1 w-100 d-none">
            <Col md={12} className="d-none d-md-block">
              <CreativeNavMenu />
            </Col>
          </Row>
        </Container>
      </nav>

      <Modal size="md" show={smShow} onHide={() => setSmShow(false)}>
        <Modal.Body>
          <UserLoginForm modalClose={setSmShow} />
        </Modal.Body>
      </Modal>

      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Wishlist</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <UserWishListPage close={handleClose} />
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        show={menuShow}
        onHide={handleMenuClose}
        placement="end"
        style={{ backgroundColor: "#136E95", color: "#fff" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title style={{ color: "#fff" }}>TeeBlanka</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>          
          <UserSidebarMenu closeModal={handleMenuClose}/>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default AppNavbar;
